// extracted by mini-css-extract-plugin
export default {"steps":"payment_steps__NOHuU","innerstep":"payment_innerstep__GAlg9","pay":"payment_pay__zakSK"};